// src/components/tools/DeleteTool.js
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

export const DeleteToolConfig = {
  name: "DELETE MEASUREMENT",
  tool: "DeleteTool",
  icon: <DeleteSweepIcon />,
};
